export const MONETIZATION_EVENTS_STORAGE_KEY = 'monetization_events_v1';
const MAX_MONETIZATION_EVENTS = 40;

export type MonetizationEventCategory = 'billing' | 'ads' | 'consent';
export type MonetizationEventStatus = 'info' | 'success' | 'error';

export type MonetizationEvent = {
  id: string;
  tsMs: number;
  category: MonetizationEventCategory;
  action: string;
  status: MonetizationEventStatus;
  detail: string;
};

export function appendMonetizationEvent(event: Omit<MonetizationEvent, 'id' | 'tsMs'> & { id?: string; tsMs?: number }): void {
  const next: MonetizationEvent = {
    id: event.id ?? `mon_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    tsMs: event.tsMs ?? Date.now(),
    category: event.category,
    action: event.action,
    status: event.status,
    detail: event.detail
  };

  const items = [next, ...listMonetizationEvents()].slice(0, MAX_MONETIZATION_EVENTS);
  localStorage.setItem(MONETIZATION_EVENTS_STORAGE_KEY, JSON.stringify(items));
}

export function listMonetizationEvents(): MonetizationEvent[] {
  const raw = localStorage.getItem(MONETIZATION_EVENTS_STORAGE_KEY);
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.flatMap(normalizeEvent).sort((a, b) => b.tsMs - a.tsMs);
  } catch {
    return [];
  }
}

export function clearMonetizationEvents(): void {
  localStorage.removeItem(MONETIZATION_EVENTS_STORAGE_KEY);
}

function normalizeEvent(value: unknown): MonetizationEvent[] {
  if (typeof value !== 'object' || value === null) return [];
  const item = value as Record<string, unknown>;
  if (item.category !== 'billing' && item.category !== 'ads' && item.category !== 'consent') return [];
  if (item.status !== 'info' && item.status !== 'success' && item.status !== 'error') return [];
  if (typeof item.action !== 'string' || item.action.trim().length === 0) return [];
  if (typeof item.detail !== 'string') return [];

  const tsMs = Number(item.tsMs ?? Date.now());
  return [
    {
      id: typeof item.id === 'string' && item.id.trim().length > 0 ? item.id : `mon_${Date.now()}`,
      tsMs: Number.isFinite(tsMs) ? tsMs : Date.now(),
      category: item.category,
      action: item.action.trim(),
      status: item.status,
      detail: item.detail
    }
  ];
}
